import AsyncPopover from './AsyncPopover';
export default AsyncPopover;
//# sourceMappingURL=index.js.map
